<template>
  <v-data-table
    :headers="headers"
    :items="instructions"
    multi-sort
    :sort-by="['version.date', 'signature.date']"
    :sort-desc="[true, true]"
    item-key="version.id"
    :items-per-page="-1"
    fixed-header
    dense
    hide-default-footer
    :no-data-text="$t('profile.history.noData')"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-subheader class="subtitle text-uppercase">{{
          $t(title)
        }}</v-subheader>
      </v-toolbar>
    </template>

    <template v-slot:[`item.code`]="{ item }">
      <span :class="getActiveStatusStyle(item)"
        >{{ item.code }}
        {{ item.isAssigned ? `(${$t("instructions.assigned")})` : "" }}</span
      >
    </template>
    <template v-slot:[`item.name`]="{ item }">
      <span :class="getActiveStatusStyle(item)">{{ item.name }}</span>
    </template>
    <template v-slot:[`item.version.revision`]="{ item }">
      <span :class="getActiveStatusStyle(item)">{{
        item.version.revision
      }}</span>
    </template>
    <template v-slot:[`item.version.dueInDays`]="{ item }">
      <span :class="getActiveStatusStyle(item)">{{
        item.version.dueInDays
      }}</span>
    </template>
    <template v-slot:[`item.signature.employee`]="{ item }">
      <span :class="getActiveStatusStyle(item)">{{
        item.signature.employee | nameId
      }}</span>
    </template>
    <template v-slot:[`item.signature.type`]="{ item }">
      <span :class="getActiveStatusStyle(item)">{{ item.signature.type }}</span>
    </template>
    <template v-slot:[`item.signature.date`]="{ item }">
      <span :class="getActiveStatusStyle(item)">{{
        item.signature.date | dateTime
      }}</span>
    </template>
    <template v-slot:[`item.signature.duration`]="{ item }">
      <span :class="getActiveStatusStyle(item)">{{
        item.signature.duration | timeDuration
      }}</span>
    </template>
    <template v-slot:[`item.signature.rereading`]="{ item }">
      <span :class="getActiveStatusStyle(item)">{{
        item.signature.rereading
      }}</span>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: ["instructions", "headers", "title"],
  methods: {
    getActiveStatusStyle(item) {
      return item && item.isActive ? "" : "grey--text";
    },
  },
};
</script>
